// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c3e3c37","732":"67f70d26","977":"055dc1ea"}[chunkId] + ".chunk.js";
};